







































































import Vue from 'vue'
import Layout from "@/router/layouts/main.vue"
import PageHeader from "@/components/page-header.vue"
import { mapGetters } from "vuex";

export default Vue.extend({
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "User account",
      items: [
        {
          text: "User account",
          href: "/",
          active: true
        }
      ],
    };
  },
  computed: {
    ...mapGetters('userModule', {
      getUserData: 'GET_USER_DATA'
    })
  }
});
